<script setup lang="ts">
import { useGtmSelectOffer } from '@/composables/useGtmTag'
import { useSimulatorData } from '@/composables/useSimulatorData'
import { UiProposalVariant } from '@afs/design-system'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import { mapSimulationProposal } from '~/extensions/simulator/simulator.mapper'

const { simulationResponse, selectedProposal } = useSimulatorData()
const { t } = useI18n()
const track = useGtmSelectOffer()

const proposals = computed(() => {
  if (simulationResponse.value) {
    let responseProposal = [simulationResponse.value.simulation]
    if (simulationResponse.value.variations) {
      responseProposal = responseProposal.concat(simulationResponse.value.variations)
    }

    responseProposal.sort((a, b) => (a.numberOfPayments < b.numberOfPayments ? -1 : 1))
    return responseProposal.map((proposal) =>
      mapSimulationProposal(
        proposal,
        proposal.id === 'main-result' ? UiProposalVariant.HIGHLIGHT : UiProposalVariant.DEFAULT,
        t,
      ),
    )
  }
  return undefined
})

const selectProposal = (e: string) => {
  if (simulationResponse.value) {
    let responseProposal = [simulationResponse.value.simulation]
    if (simulationResponse.value.variations) {
      responseProposal = responseProposal.concat(simulationResponse.value.variations)

      selectedProposal.value = responseProposal.find((proposal) => proposal.id === e) || null
    }
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const submitProposal = (e: any) => {
  if (e.target?.innerText && selectedProposal.value?.id) {
    track(e.target.innerText, selectedProposal.value.id)
  }
}
</script>

<template>
  <div class="Proposals">
    <div
      v-if="proposals"
      class="Proposals__list g-4 py-2"
      :class="{ 'Proposals__list__two-columns': proposals.length === 2 }"
    >
      <molecules-ui-proposal
        v-for="proposal in proposals"
        v-bind="proposal"
        :key="proposal.id"
        class="Proposals__item"
        :selected="selectedProposal?.id === proposal.id"
        @proposal::on-select="selectProposal"
      />
    </div>
    <div class="Proposals__cta bg-white px-4 py-3">
      <atoms-ui-button
        id="select-proposal"
        class="ml-auto"
        :text="$t('simulator.proposals.validButton.label')"
        to="/formulaire-souscription"
        :disabled="!selectedProposal.id"
        @click="submitProposal"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'config/spaces';
@use 'utilities/mq';

.Proposals__list {
  @include mq.media('<medium') {
    display: flex;
    margin-left: calc(var(--layout-padding) * -1);
    margin-right: calc(var(--layout-padding) * -1);
    padding-left: var(--layout-padding);
    padding-right: var(--layout-padding);
    overflow-x: auto;
  }

  @include mq.media('>=medium') {
    display: grid;
    grid-template-columns: repeat(3, 1fr);

    &__two-columns {
      grid-template-columns: repeat(2, 340px);
      justify-content: center;
    }
  }
}

.Proposals__item {
  @include mq.media('<medium') {
    flex-basis: 300px;
    flex-shrink: 0;
  }

  .Card {
    height: 100%;
  }
}

.Proposals__cta {
  z-index: 10;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  box-shadow: 0px 0px 32px 0px rgba(0, 59, 69, 0.16);
}
</style>
